/**
 * 
 * @param name 需要被处理的名字
 */
export default function dealWithName(name: string): string {
  if (name.length === 1) {
    return name + '*';
  }
  if (name.length === 2) {
    return name.slice(0, 1) + '*';
  }
  if (name.length > 2) {
    return name.slice(0, 1) + '*' + name.slice(name.length - 1);
  }
  return name;
}